import { jsx as _jsx } from "react/jsx-runtime";
export function ModuleFallbackComponent({ 
// I want to keep them for reference in future
// eslint-disable-next-line @typescript-eslint/no-unused-vars
error, 
// eslint-disable-next-line @typescript-eslint/no-unused-vars
resetErrorBoundary, }) {
    // TODO: make retry of loading module right from fallback component
    return (_jsx("div", { role: "alert", children: _jsx("p", { children: "Service is unavailable" }) }));
}
export function moduleLoadingError(error, info) {
    console.error('Caught an error:', error, info);
}
